import * as basic from './basic';
import * as converter from './converter';

const op = {
  ...basic,
  ...converter,
};

export default op;
